import React, {useState} from "react"
import Swal from "sweetalert2"
import {URL} from "../../config"
// import "./styles_forms/Login.css"

const Login = () => {

	const [formData, setFormData] = useState({})


	const onChangeHandler = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value
		})
	}
	// console.log(formData)


	const onSubmitHandler = (e) => {

		let reqOptions = {

			method: "POST",
			body: JSON.stringify(formData),
			headers : {
				"Content-Type" : "application/json"
			}
		}
		e.preventDefault()
		fetch(`${URL}/users/login`, reqOptions)
		.then(res => res.json())
		.then(data=>{

			if(data.auth){

				Swal.fire({

						icon: 'success',
						title: data.message,
						timer: 3500,
						showConfirmButton: false

				})
			localStorage.setItem("user", JSON.stringify(data.user))
			localStorage.setItem("token", data.token)
			let cartItems = []
			localStorage.setItem("cartItems", JSON.stringify(cartItems))
			window.location.href="/"

			} else {

				Swal.fire({
					icon: 'error',
					text: data.message,
					timer: 3500,
					showConfirmButton: false
				})
			}
		})
	}


return(
	<div className="login-background">
	<div className="container col-sm-4 mx-auto" onSubmit={onSubmitHandler}>
		<div className="card login text-white">
			<div className="card-header headerLoginBackground">
				<h3>Login</h3>
			</div>
			<div className="card-body">
				<form>
					<div className="form-group">
						<label htmlFor="username">Username</label>
						<input type="text" className="form-control" name="username" id="username" onChange={onChangeHandler} />
					</div>
					<div className="form-group mb-4">
						<label htmlFor="password">Password</label>
						<input type="password" className="form-control" name="password" id="password" onChange={onChangeHandler} />
					</div>

					<button className="btn btn-primary">Login</button>
				</form>
			</div>
		</div>
	</div>
	</div>
	)
}

export default Login;